import { render, staticRenderFns } from "./serviceStatistics.vue?vue&type=template&id=4529b066&scoped=true"
import script from "./serviceStatistics.vue?vue&type=script&lang=js"
export * from "./serviceStatistics.vue?vue&type=script&lang=js"
import style0 from "./serviceStatistics.vue?vue&type=style&index=0&id=4529b066&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./serviceStatistics.vue?vue&type=style&index=1&id=4529b066&prod&lang=css"
import style2 from "./serviceStatistics.vue?vue&type=style&index=2&id=4529b066&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4529b066",
  null
  
)

export default component.exports